module.exports = __webpack_public_path__ + "media/images/admin/icons/code-5006cb1eb2fba36c6c80bfb24f55e45a.svg";